export const buildDefaultReminder = (criticalDateOptions) => {
  return {
    dateReference: criticalDateOptions[0]?.value,
    modifier: 0,
    recipients: 'all_internal_brokers',
    units: unitOptions[0].value,
  };
};

export const unitOptions = [
  {
    label: 'Days',
    value: 'day',
  },
  {
    label: 'Weeks',
    value: 'week',
  },
  {
    label: 'Months',
    value: 'month',
  },
];

export const recipientsOptions = [
  {
    label: 'All Internal Brokers',
    value: 'all_internal_brokers',
  },
  {
    label: 'All Internal Brokers + Deal Admins',
    value: 'all_internal_brokers_and_deal_admins',
  },
  {
    label: 'All Internal Brokers + Deal / Office / Company Admins',
    value: 'all_internal_brokers_and_all_admins',
  },
  {
    label: 'Office / Company Admins Only',
    value: 'apex_admins',
  },
  {
    label: 'Primary Broker Only',
    value: 'primary_broker',
  }
];
